import { render, staticRenderFns } from "./PureSpotSupport.vue?vue&type=template&id=b54aa574"
import script from "./PureSpotSupport.vue?vue&type=script&lang=js"
export * from "./PureSpotSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports